import { render, staticRenderFns } from "./PlateStockPopularTable.vue?vue&type=template&id=2c41c489&scoped=true"
import script from "./PlateStockPopularTable.vue?vue&type=script&lang=js"
export * from "./PlateStockPopularTable.vue?vue&type=script&lang=js"
import style0 from "./PlateStockPopularTable.vue?vue&type=style&index=0&id=2c41c489&prod&scoped=true&lang=css"
import style1 from "./PlateStockPopularTable.vue?vue&type=style&index=1&id=2c41c489&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41c489",
  null
  
)

export default component.exports